export enum Frequency {
	MONTHLY = 'MONTHLY',
	SEMI_MONTHLY = 'SEMI_MONTHLY',
	QUARTERLY = 'QUARTERLY',
	ANNUAL = 'ANNUAL',
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY'
}